import { getApiClient } from '@/lib/api/api-client';
import { CacheService } from '../cache';
import { isColorDark } from '@/lib/utils/color-utils';
import type { Tier } from '@/types/tier';

// type fix
// Runtime'da Tier tipine textColor eklemek için genişletilmiş tip
interface TierWithTextColor extends Tier {
  textColor: string;
}

/**
 * Tiers API service
 */
export class TiersAPI {
  static apiClient = getApiClient();
  private static CACHE_DURATION = 5 * 60 * 1000;

  /**
   * Get tiers data
   */
  static async getTiersData(): Promise<TierWithTextColor[] | null> {
    const cacheKey = 'tiersData';
    const cachedData = CacheService.getFromCache(cacheKey);
    if (cachedData) {
      return cachedData as TierWithTextColor[];
    }

    const tiersData = await TiersAPI.apiClient.collections.tiers.find({
      limit: 100,
      depth: 2,
    });
    
    // Her tier için rengin koyu mu açık mı olduğunu belirle
    const processedTiers = tiersData.docs.map((tier) => {
      // Tier nesnesini TierWithTextColor'a dönüştür
      const tierWithTextColor = tier as TierWithTextColor;
      
      // Renk koyu ise textColor'ı #fff, açık ise #000 olarak ayarla
      if (tier.color) {
        const isDark = isColorDark(tier.color);
        tierWithTextColor.textColor = isDark ? '#fff' : '#000';
      } else {
        tierWithTextColor.textColor = '#000'; // Varsayılan olarak siyah metin
      }
      return tierWithTextColor;
    });

    CacheService.addToCache(cacheKey, processedTiers, TiersAPI.CACHE_DURATION);
    return processedTiers;
  }
}
